import { render, staticRenderFns } from "./AppCoverUpload.vue?vue&type=template&id=13310711"
import script from "./AppCoverUpload.vue?vue&type=script&lang=js"
export * from "./AppCoverUpload.vue?vue&type=script&lang=js"
import style0 from "./AppCoverUpload.vue?vue&type=style&index=0&id=13310711&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports